import { useState } from "react";
import apiClient from "../../utils/apiClient";
import { toast } from "react-toastify";
import Button from "../../components/ui/button";
import { useSelector } from "react-redux";

const OTPComponent = ({
  body,
  onSuccess = () => { },
}: {
  body: any;
  onSuccess?: any;
}) => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const [otp, setOtp] = useState("");
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  const generateOTP = async () => {
    setIsGenerating(true);
    try {
      const response = await apiClient.post(
        "/user/generate-otp-for-activity",
        body
      );
      if (response.data.status === 200) {
        setIsOtpGenerated(true);
        toast.success("OTP sent successfully!");
      } else {
        toast.error("Failed to generate OTP");
      }
    } catch (error) {
      toast.error("Error generating OTP");
    } finally {
      setIsGenerating(false);
    }
  };

  const verifyOTP = async () => {
    if (!otp.trim()) {
      toast.error("Please enter OTP");
      return;
    }

    setIsVerifying(true);
    try {
      const response = await apiClient.post("/user/verify-otp-for-activity", {
        ...body,
        otp,
      });
      if (response.data.status === 200) {
        toast.success("OTP verified successfully!");
        await onSuccess();
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      toast.error("Error verifying OTP");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleOtpInput = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only allow digits
    setOtp(value);
  };

  return (
    <div className="container-fluid p-0">
      {!isOtpGenerated ? (
        <div className="text-center">
          <div className="mb-4">
            <i className="fas fa-mobile-alt fa-3x text-primary mb-3"></i>
            <p className="text-muted">
              Click the button below to receive an OTP on your registered email
            </p>
          </div>

          <Button
            onClick={generateOTP}
            disabled={isGenerating}
            className="btn btn-primary btn-lg px-4 py-2"
          >
            {isGenerating ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Generating...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane mr-2"></i>
                Generate OTP
              </>
            )}
          </Button>
        </div>
      ) : (
        <div>
          <div className="text-center mb-4">
            <i className="fas fa-shield-alt fa-3x text-success mb-3"></i>
            <h6 className="fw-bold">Enter Verification Code</h6>
            <p className="text-muted small">
              We've sent a 6-digit code to your registered email
            </p>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="mb-4">
                <label htmlFor="otpInput" className="form-label fw-semibold">
                  OTP Code
                </label>
                <input
                  id="otpInput"
                  type="text"
                  className="form-control form-control-lg text-center fs-4 letter-spacing-2"
                  value={otp}
                  onChange={handleOtpInput}
                  placeholder="000000"
                  maxLength={6}
                  autoFocus
                  style={{
                    letterSpacing: "0.5em",
                    fontFamily: "monospace",
                  }}
                />
                <div className={`${theme == "light" ? "text-dark" : ""} form-text text-center`}>
                  {6 - otp.length} digits remaining
                </div>
              </div>

              <div className="d-flex justify-content-between w-100 gap-2">
                <button
                  type="button"
                  className="btn btn-danger btn-sm text-flex-nowrap"
                  onClick={() => {
                    setIsOtpGenerated(false);
                    setOtp("");
                  }}
                >
                  <i className="fas fa-arrow-left text-sm-start mr-2"></i>
                  Back to Generate
                </button>

                <Button
                  onClick={verifyOTP}
                  disabled={isVerifying || otp.length !== 6}
                  className="btn btn-primary btn-sm text-nowrap"
                >
                  {isVerifying ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Verifying...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check-circle mr-2"></i>
                      Verify OTP
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OTPComponent;
